import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  QueryResult,
  Searchbar,
  SearchInput,
  GrantsSearchContainer,
  HiddenFrequency,
  ContributionSearchLabel,
} from "../styles";
import MultiSelect from "./Select";
import Calender from './DateTimepicker/Calender';
import { connect } from 'react-redux';
import moment from "moment";
import { contributionSearchState } from "../selectors";
const Search = SearchInput;

export class ContributionSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: null,
      dates: null,
      status: null,
      visible: false
    };
}

onCancel = () => {
  this.setState({visible : false})
}

  render() {
    const options= this.props.dropDownValues ? this.props.dropDownValues : [];
    return (
      <GrantsSearchContainer>
        <Searchbar>
          <ContributionSearchLabel>Status</ContributionSearchLabel>          
              <MultiSelect options={options} handleDropper={this.props.handleDropper} menu={this.props.menu}/>
          <ContributionSearchLabel marginLeft="30px">Time Frame</ContributionSearchLabel>
          <Calender
            style={{ width: 200 }}
            visible={this.state.visible}
            onCancel={() => this.onCancel()}
          >
            Select TimeFrame
          </Calender>
      
          <div style={{ width: "35px" }} />
        </Searchbar>
      </GrantsSearchContainer>
    );
  }
}

ContributionSearch.propTypes = {
  dropDownValues: PropTypes.array
}


const mapStateToProps = (state) =>({
  ...contributionSearchState(state.toJS())
});
  
  export default connect(mapStateToProps,null)(ContributionSearch);
 